import { useState, ChangeEvent, useEffect } from "react";
import { useAutoFocus } from "../../hooks/useAutoFocus";
import {
  Wrapper,
  RoundedInput,
  RoundedButton,
  LinkButton,
  Row,
} from "../Components";
import { ScreenProps } from "../../types/ScreenTypes";
import { PANTERA } from "../../utils/colors";
import { LOG_IN } from "../../constants/buttonIds";
import axios from "axios";
import { SetLocalStorage, urls } from "../api/api";

function LoginScreen({ cti, handleNextScreen }: ScreenProps) {
  const usernameInput = useAutoFocus();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userInformation, setUserInformation] = useState("");
  const [error, setError] = useState(""); 
  const [showTest, setShowTest] = useState(false); 

  const handleLogin = async () => {
    setError("");
    try {
      const form_data = new FormData();
      form_data.append("email", username);
      form_data.append("pwd", password);
      const response = await axios.post(urls.loginV2, form_data);
      setUserInformation(response.data);
      if (response.data.type === "success") {
        SetLocalStorage("userInformation", response.data);
        handleNextScreen();
        cti.userLoggedIn();
      } else if (response.data.type === "error") {
        setError(response.data.message || "Login failed. Please try again.");
      } else {
        setError("Unexpected response from the server.");
      }
    } catch (error) {
      setError("Login request failed. Please check your connection.");
    }
  };
useEffect(()=>{
  const userInfo = localStorage.getItem("userInformation");
  if(userInfo){
    handleNextScreen();
    cti.userLoggedIn();
  }
})

  const handleUsername = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => setUsername(value);

  const handlePassword = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => setPassword(value);

  
  return (
    <Wrapper style={{ color: PANTERA }}>
      <form>
        <h4 style={{ textAlign: "center" }}>Log into your calling account</h4>
        <div style={{ marginBottom: "5px", fontSize: "14px" }}>User Name</div>
        <RoundedInput
          value={username}
          onChange={handleUsername}
          ref={usernameInput}
          autoComplete="username"
        />
        <div style={{ marginBottom: "5px", fontSize: "14px" }}>Password</div>
        <RoundedInput
          type="password"
          value={password}
          onChange={handlePassword}
          autoComplete="current-password"
        />
        {error && (
          <div
            style={{
              color: "red",
              marginTop: "10px",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}
        <br />
        <Row>
          <RoundedButton
            use="primary"
            onClick={handleLogin}
            type="button"
            data-test-id={LOG_IN}
          >
            Log in
          </RoundedButton>
        </Row>
        <br />
       
      </form>
    </Wrapper>
  );
}

export default LoginScreen;
